import React from 'react'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

function LogoutModal({ visible, setVisible,message,onAccept,title="" }) {
  return (
    <Modal show={visible} onHide={setVisible}>
        
        <Modal.Header >
            <Modal.Title style={{color:"red"}}>
                {title}
            </Modal.Title>
        </Modal.Header>

        <Modal.Body>
             <p className='body'>{message}</p>
        </Modal.Body>

        <Modal.Footer>
        <Button variant="primary" style={{backgroundColor:"red",borderColor:"red"}} onClick={onAccept}>
          OK
        </Button>
            
        </Modal.Footer>
            
       
    </Modal>
  )
}


export default LogoutModal